<template>
  <div class="laypanel">
    <el-tabs v-model="qdtab" type="card" style="margin-left:40px;margin-right:40px;height: 200px;">
      <el-tab-pane label="会员卡管理" name="cardgl">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
              <el-form-item label="卡等级">
                <el-select v-model="viplevel" filterable placeholder="请选择类别">
                  <el-option
                    v-for="item in leveldata"
                    :key="item.level"
                    :label="item.level"
                    :value="item.level"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="卡标题">
                <el-input v-model="cardtitle"></el-input>
              </el-form-item>
              <el-form-item label="上传卡背景" class="yyzz_upload">
                <UpLoadFile ref="upfile" @upok="upok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifimg="ifimg" :curfilepath="curfilepath" :bucketpath="bucketpath"></UpLoadFile>
              </el-form-item>
            </el-form>
            <div class="savebasepanel">
              <el-button type="primary" icon="el-icon-plus" @click="addnewcard">添加新卡</el-button>
              <el-button type="success" icon="el-icon-edit-outline" @click="savenewcard">保存修改</el-button>
            </div>
          </el-col>
          <el-col :span="12" >
            <el-table
              stripe
              :header-cell-style="{'text-align':'center'}"
              :data="carddata"
              ref="multipleTable">
              <el-table-column
                prop="levelid"
                label="卡级别"
              >
              </el-table-column>
              <el-table-column
                prop="cardtitle"
                label="标题"
              >
              </el-table-column>
              <el-table-column
                label="卡牌背景">
                <template slot-scope="scope">
                  <div v-if="scope.row.cardimg">
                    <img :src="scope.row.cardimg" class="bigavatarimg">
                  </div>
                  <div v-else>
                    {scope.row.cardimg}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="调整卡片" placement="top-start">
                    <i class="fa fa-eye ciicon fa-lg curpointer" v-on:click="editcard(scope.$index, carddata)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="移除该卡" placement="top-start">
                    <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removecard(scope.$index, carddata)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="等级管理" name="cardlevelgl">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="100px" label-position="left" class="tabcard">
              <el-form-item label="等级">
                <el-input v-model="cardlevel"></el-input>
              </el-form-item>
              <el-form-item label="百分比">
                <el-input v-model="cardpercent"></el-input>
              </el-form-item>
              <el-form-item label="额度">
                <el-input v-model="cardcount"></el-input>
              </el-form-item>
            </el-form>
            <div class="savebasepanel">
              <el-button type="success" icon="el-icon-edit-outline" @click="savenewlevel">保存修改</el-button>
            </div>
          </el-col>
          <el-col :span="12">
            <el-table
              stripe
              :header-cell-style="{'text-align':'center'}"
              :data="leveldata"
              ref="multipleTable">
              <el-table-column
                prop="level"
                label="等级"
              >
              </el-table-column>
              <el-table-column
                prop="percent"
                label="百分比"
              >
              </el-table-column>
              <el-table-column
                prop="count"
                label="额度"
              >
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="修改百分比" placement="top-start">
                    <i class="fa fa-eye ciicon fa-lg curpointer" v-on:click="editlevel(scope.$index, leveldata)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="移除该等级" placement="top-start">
                    <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="removelevel(scope.$index, leveldata)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import UpLoadFile from '../upload/UpLoadFile'
Vue.prototype.$http = axios
var that
export default {
  name: 'MemberCard',
  components: {
    UpLoadFile
  },
  data () {
    return {
      qdtab: 'cardgl',
      cardupparms: {'bucketname': 'wyzb1', 'bucketpath': 'member'},
      carddata: [],
      bucketpath: 'ecomm/card',
      viplevels: [],
      viplevel: '',
      khid: '',
      cardtitle: '',
      cardimg: '',
      ifshowfile:false, // 上传页面参数： 是否显示文件
      curfilepath: '', // 上传页面参数： 当前选中图标文件路径
      ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
      ifimg1: false, // 上传页面参数： 上传方式是否设定为 图片模式
      ifupload: false, // 上传页面参数： 是否显示上传参数
      cardbackurlok: false,
      cardbackurl: '',
      cardlevel: '',
      cardpercent: '',
      selcardlevel: '',
      selcardinfo: '',
      cardcount: '',
      leveldata: []
    }
  },
  mounted: function () {
    that = this
    that.getcarddata()
    that.getlevel()
  },
  methods: {
    upok (curpath,fileList) {
      that.cardbackurlok = true
      that.cardbackurl = curpath
      that.curfilepath = curpath
      that.cardimg = curpath
    },
    getcarddata () {
      var qstr1 = " ownphone = '" + localStorage.getItem('username') + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querycardmana',
        method: 'post',
        data: {
          whereinfo: qstr1,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.carddata = res.data
          } else {
            that.carddata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getlevel () {
      var qstr1 = " ownphone = '" + localStorage.getItem('username') + "'"
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querycardlevel',
        method: 'post',
        data: {
          whereinfo: qstr1,
          limit: '',
          sortinfo: ''
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.leveldata = res.data
          } else {
            that.leveldata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    OnCardSuccess (res, rfile, fileList) {
      if (res.success) {
        this.glbackimgurlok = true
        console.log(res.data[0].osspath)
        this.cardimg = res.data[0].osspath
        this.cardbackurl = res.data[0].osspath
        console.log(this.cardbackurl)
        that.$message({
          type: 'success',
          message: '上传成功!'
        })
      }
    },
    OnCardError () {},
    BeforeCardUpload () {},
    addnewcard () {
      console.log('addnewcard')
      window.console.log(that.cardtitle)
      window.console.log(that.cardimg)
      if (that.cardtitle === '' || that.cardimg === '') {
        that.$message({
          type: 'info',
          message: '信息不完整!'
        })
      } else {
        var addcard = {
          id: '',
          levelid: that.viplevel.toString(),
          cardtitle: that.cardtitle,
          cardimg: that.cardimg,
          cusid: localStorage.getItem('cusid').toString(),
          ownphone: localStorage.getItem('username').toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addcardmana',
          method: 'post',
          data: addcard,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.cleardata()
              that.getcarddata()
              that.$message({
                type: 'success',
                message: '添加成功!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '添加失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    savenewcard () {
      if (that.cardtitle === '' || that.cardimg === '') {
        that.$message({
          type: 'info',
          message: '信息不完整!'
        })
      } else {
        var addcard = {
          id: that.selcardinfo.id.toString(),
          levelid: that.viplevel.toString(),
          cardtitle: that.cardtitle,
          cardimg: that.cardimg,
          cusid: localStorage.getItem('cusid').toString(),
          ownphone: localStorage.getItem('username').toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addcardmana',
          method: 'post',
          data: addcard,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.cleardata()
              that.getcarddata()
              that.$message({
                type: 'success',
                message: '更新成功!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '更新失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    savenewlevel () {
      if (that.cardlevel === '' || that.cardpercent === '' || that.cardcount === '') {
        that.$message({
          type: 'info',
          message: '信息不完整!'
        })
      } else {
        var addcard = {
          level: that.cardlevel.toString(),
          percent: that.cardpercent.toString(),
          count: that.cardcount.toString(),
          cusid: localStorage.getItem('cusid').toString(),
          ownphone: localStorage.getItem('username').toString()
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addcardlevel',
          method: 'post',
          data: addcard,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.cleardata()
              that.getlevel()
              that.$message({
                type: 'success',
                message: '更新成功!'
              })
            } else {
              that.$message({
                type: 'error',
                message: '更新失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    removecard (index, data) {
      var selectdata = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/delcardmana',
        method: 'post',
        data: {
          id: selectdata.id.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.getcarddata()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    editlevel (index, data) {
      console.log(data[index])
      var datatmp = data[index]
      that.selcardlevel = datatmp
      that.cardlevel = datatmp.level
      that.cardpercent = datatmp.percent
      that.cardcount = datatmp.count
    },
    editcard (index, data) {
      var datatmp = data[index]
      console.log(datatmp)
      that.selcardinfo = datatmp
      that.viplevel = parseInt(datatmp.levelid)
      that.cardtitle = datatmp.cardtitle
      that.cardimg = datatmp.cardimg
      that.curfilepath = datatmp.cardimg
    },
    removelevel (index, data) {
      var selectdata = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/delcardlevel',
        method: 'post',
        data: {
          level: selectdata.level.toString(),
          ownphone: selectdata.ownphone.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.result === 'success') {
            that.getlevel()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    cleardata () {
      that.levelid = ''
      that.cardtitle = ''
      that.curfilepath = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/member/MemberCard.vue